import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
    motorMakeAll: [],
    motorMake: {},
    currentPage: 1,
    totalPages: 1,
    rowsPerPage: 10,
    sortBy: "name",
    sortOrder: "asc",
};

const motorMakeSlice = createSlice({
    name: "motorMake",
    initialState,
    reducers: {
        setMotorMakeAll: (state, action) => {
            state.motorMakeAll = action.payload;
        },
        setMotorMake: (state, action) => {
            state.motorMake = action.payload;
        },
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload;
        },
        setTotalPages: (state, action) => {
            state.totalPages = action.payload;
        },
        setRowsPerPage: (state, action) => {
            state.rowsPerPage = action.payload;
        },
    },
}) 

export const { setMotorMakeAll, setMotorMake, setCurrentPage, setTotalPages, setRowsPerPage } = motorMakeSlice.actions;
export default motorMakeSlice.reducer;